import {
    FETCH_ALL_PATIENT_SUCCESS, 
    EDIT_PATIENT, 
    UPDATE_PATIENT_SUCCESS, 
    CREATE_PATIENT_SUCCESS, 
    DELETE_PATIENT_SUCCESS,
    SET_PATIENT,
    SET_ROLE,
} from "constants/patients.constants";

const INIT_STATE = {
    patients: [],
    roles:[],
    patient: {
        id: 0,
        first_name: '',
        last_name: '',
        email: '',
        phone_no: '',
        address: '',
        dob: '',
        country:null,
        gender:'',
        status: 0,
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case SET_ROLE: {
            let c = Object.assign({}, state.patient);
            let s = Boolean(action.value)

            var str = "";
            if (c.role_ids !== undefined) {
                str = c.role_ids;
            }

            if (s) {
                if (str === "") {
                    str = "" + action.key;
                } else {
                    str = str + "," + action.key;
                }
            } else {
                str = c.role_ids.replace(new RegExp(action.key + ',?'), '');
            }
            c.role_ids = str
            return {
                ...state,
                patient:c
            }
        }
        //set patient
        case SET_PATIENT: {
            let c = Object.assign({}, state.patient);
            c[action.key] = action.value
            return {
                ...state,
                patient: c
            }
        }
        case FETCH_ALL_PATIENT_SUCCESS: {
            return {
                ...state,
                patients: action.payload.users,
                pagination: action.payload.page
            }
        }

        case UPDATE_PATIENT_SUCCESS: {
            let foundIndex = state.patients.findIndex(x => x.id === action.payload.user.id);
            let all = Object.assign([], state.patients);
            let o =  action.payload.user
            all[foundIndex] = o
            return {
                ...state,
                patients: all,
                patient: o,
            }
        }

        case CREATE_PATIENT_SUCCESS: {
            let all = Object.assign([], state.patients);
            all.push(action.payload.data)
            return {
                ...state,
                patients: all,
                patient: INIT_STATE.patient
            }
        }

        case DELETE_PATIENT_SUCCESS: {
            let all = Object.assign([], state.patients);
            let newPatientList = all.filter(patient => patient.id !== action.payload);
            return {
                ...state,
                patients: newPatientList,
            }
        }

        case EDIT_PATIENT: {
            let u = state.patients.find(c => c.id === action.payload)
            let o = Object.assign({}, u)
        
           // o.country_id = o.country.id
           // o.patient_type_id = o.partner_type.id
            return {
                ...state,
                patient: o
            }
        }
        
        default:
            return state;
    }
}